import { useContext, useEffect, useState } from "react"
import { Box, Button, useMediaQuery } from "@mui/material"
import { ToolContext } from "../../../../core/context/ToolContext";
import { CstmTextField } from "../../../../core/global/forms/CstmTextField";
import { SalesReportRead, SalesReportSubmit } from "../../global/API";
// import { Loader } from "./Loader";
import { ConfirmationWarning } from "../../../../core/global/modal/Confirmation";
import { Warning } from "../../../../core/global/modal/Warning";
import { MessageModal } from "../../../../core/global/modal/MessageModal";
import moment from "moment";

export const Index = () => { 
    const { tool_state, session_state, report_state, personalization_state} = useContext(ToolContext)
    const { __SESSION: {data: {ainfo, pinfo, uaccess}} } = {...tool_state}
    const { sessionData, navSession } = session_state
    const { eodSales, messageModal } = report_state
    const { startHere} = personalization_state
    let user_id = parseInt(atob(ainfo.aid).split('_', 2)[1]);

    const [form, setForm] = useState({remarks:''})
    const [submitFormLoader, setSubmitFormLoader] = useState({submit:true, modal:false, loader:false})
    const [isLoading, setIsLoading] = useState(true)
    const sm = useMediaQuery('(max-width:500px)')

const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "remarks") {
        setForm((prev) => ({ ...prev, [name]: value }));
        return;
    }

    const input = e.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    const oldFormattedLength = oldValue.length;

    let rawValue = value.replace(/[₱,\s]/g, '');
    
    if (rawValue === '') {
        let updatedData = { ...eodSales.data };
        updatedData[name] = '';
        updatedData.display_actual_sales = '';
        updatedData['variance'] = parseFloat(0 - eodSales.data.total_sales).toFixed(2);
        
        eodSales.set(updatedData);
        setSubmitFormLoader({
            ...submitFormLoader,
            submit: true
        });
        return;
    }

    if (rawValue === '.') {
        let updatedData = { ...eodSales.data };
        updatedData[name] = '0.';
        updatedData.display_actual_sales = '₱0.';
        updatedData['variance'] = parseFloat(0 - eodSales.data.total_sales).toFixed(2);
        
        eodSales.set(updatedData);
        setSubmitFormLoader({ ...submitFormLoader, submit: true});
        
        setTimeout(() => {
            input.setSelectionRange(3, 3); 
        }, 0);
        return;
    }

    if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return;

    const numericValue = parseFloat(rawValue);
    
    let formattedValue;
    if (rawValue.endsWith('.')) {
        formattedValue = `₱${Math.floor(numericValue).toLocaleString('en-PH')}.`;
    } else if (rawValue.includes('.')) {
        const decimalPlaces = rawValue.split('.')[1].length;
        formattedValue = `₱${numericValue.toLocaleString('en-PH', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        })}`;
    } else {
        formattedValue = `₱${numericValue.toLocaleString('en-PH')}`;
    }

    let updatedData = { ...eodSales.data };
    updatedData[name] = rawValue;
    updatedData.display_actual_sales = formattedValue;

    const variance = numericValue - eodSales.data.total_sales;
    updatedData['variance'] = variance.toFixed(2);

    eodSales.set(updatedData);
    
    setSubmitFormLoader({...submitFormLoader,submit: !(numericValue > 0)});

    const newFormattedLength = formattedValue.length;
    const lengthDifference = newFormattedLength - oldFormattedLength;
    
    setTimeout(() => {
        const newCursorPosition = cursorPosition + lengthDifference;
        const clampedPosition = Math.max(1, Math.min(newCursorPosition, formattedValue.length));
        input.setSelectionRange(clampedPosition, clampedPosition);
    }, 0);
};
    const submitHandler = async(type) => {
        if (type === 'submit') {
            setSubmitFormLoader({...submitFormLoader, modal:true})
            return
        }

        if (type === 'cancel') {
            setSubmitFormLoader({...submitFormLoader, modal:false})
            return
        }else{
            setSubmitFormLoader({...submitFormLoader, loader:true})
            setIsLoading(true)
            let body = {
                branch_id:sessionData.data.branch_id,
                user_id:user_id,
                sales: parseFloat(eodSales.data.actual_sales) || 0,
                variance: parseFloat(eodSales.data.variance) || 0,
                remarks:form.remarks
            }
            let res = await SalesReportSubmit(body)
            if (res === 'success') {
                navSession.set((prev) => ({...prev, isShow:false}))
                setIsLoading(false)
                eodSales.set((prev) => ({...prev, eod:eodSales.data.actual_sales, actual_sales:0}))
                setSubmitFormLoader({...submitFormLoader, modal:false, loader:false})
                if (startHere.data.show) {
                    startHere.set(prev => ({...prev, tasks: {...prev.tasks, branch_sales: true}}));
                    startHere.set(prev =>({...prev, modal: true}))
                }
            }
        }
    }

    const __init = async() => {
        eodSales.set((prev) => ({...prev, total_sales:0, actual_sales:0, eod:0, display_actual_sales: 0}))
        setIsLoading(true) 
        let qsp = {
            filter:'per_user',
            branch_id:sessionData.data.branch_id,
            user_id:user_id,
            company_id: uaccess[0].company_id, 
        }
        let res = await SalesReportRead(qsp)
        if (res) {
            setForm({...form, remarks: res.remarks === null ? '' : res.remarks})
            eodSales.set(prev => ({ ...prev, total_sales: res.total_sales || 0, eod: (res.recon_sales && res.recon_sales.actual_cash) ? res.recon_sales.actual_cash : parseFloat(res.eod_sales || 0) }));
            const showModal = (text, subText) => { messageModal.set({ ...messageModal.data, text, subText }); navSession.set({ ...navSession.data, isShow: true });};       
            if (res.recon_sales === 0 &&  res.eod_sales !== 0) {showModal("Review submitted Sales Report", "You can check it in the Reconciliation Tab"); setIsLoading(false); return;}
            if (res.prev_sales !== 4 && res.prev_sales !== 0 && res.check_recon > 0 && !res.recon_sales.actual_cash) {showModal("Review Sales of Previous Day First", "You can check it in the Reconciliation Tab"); setIsLoading(false); return; }
            switch (res.recon_sales.status) {
                case 1:
                    showModal("Review submitted Sales Report", "You can access your End of Day Sales in the Reconciliation Tab");
                    break;
                case 2:
                    showModal("Sales Report was submitted for Review", "Please wait for approval of your end of day sales");
                    break;
                case 3:
                    showModal("Sales Report was recommended for Approval", "Please wait for approval of your end of day sales");
                    break;
                default:
                    navSession.set({...navSession.data, isShow:false });
                    break;
            }
            setIsLoading(false)
        }
    }

    useEffect(() => {
        __init()
        // eslint-disable-next-line
    }, [])
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" px={1.5}>
            <Box minHeight="10px"></Box>
            { sessionData.data.modal ? 
                <Box width="100%" display="flex" alignItems="center" justifyContent="center" mt={10}>
                    <Warning message={"You currently haven't selected a branch"} messageDetails={"Please select the branch at the home tab to encode the end-of-day inventory."} />
                </Box>
            :
                <Box height="auto" width="100%" bgcolor="#FFFFFF" borderRadius="4px" p={2} display="flex" flexDirection="column" gap={1}>
                    <Box width="100%" textAlign="center" fontWeight={700}>
                        End of Day Sales {eodSales.data.eod !== 0 ? 'Report' : 'Entry'}
                    </Box>
                    <Box width="100%" display="flex" flexDirection="column" gap={1} py={2}>
                        <Box width="100%" display="flex" gap={2} >
                            <Box fontSize={14} fontWeight={400}> Branch Name :  </Box>
                            <Box fontSize={14} fontWeight={700}> {sessionData.data.branch_name} Branch </Box>
                        </Box>
                        <Box width="100%" display="flex" gap={2} >
                            <Box fontSize={14} fontWeight={400}> Person in charge :  </Box>
                            <Box fontSize={14} fontWeight={700}> {pinfo.length === 0 ? 'Hero' : `${pinfo[0].first_name} ${pinfo[0].last_name}` } </Box>
                        </Box>
                        <Box width="100%" display="flex" gap={2}>
                            <Box fontSize={14} fontWeight={400}> Date :  </Box>
                            <Box fontSize={14} fontWeight={700}> {moment(new Date()).format("MM-DD-YYYY")} </Box>
                        </Box>
                    </Box>
                    {eodSales.data.eod !== 0   ? 
                        <>
                            <Box width="100%" display="flex" flexDirection="column" gap={1}>
                                <Box fontSize={14} fontWeight={400}>Total Sales:</Box>
                                <CstmTextField fullWidth variant="outlined"
                                    value={`₱ ${parseFloat(eodSales.data.total_sales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                    inputProps={{min: 0, style: { textAlign: 'right' }}} disabled
                                />
                            </Box>
                            <Box width="100%" display="flex" flexDirection="column" gap={1}>
                                <Box fontSize={14} fontWeight={400}>Actual Cash:</Box>
                                <CstmTextField 
                                    fullWidth 
                                    variant="outlined"
                                    onInput={(e)=>handleChange(e)}
                                    name="actual_sales"
                                    value={`₱ ${parseFloat(eodSales.data.eod).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                    placeholder="₱0.00"
                                    inputProps={{min: 0, style: { textAlign: 'right' }}} 
                                    error={eodSales.data.actual_sales === '.'}
                                    disabled
                                />
                            </Box>
                            <Box width="100%" display="flex" justifyContent="space-between" gap={1} pr="9px" py={2}>
                                <Box fontSize={14} fontWeight={700}>Variance:</Box>
                                <Box fontWeight={700}> {parseFloat(eodSales.data.eod, 10) !== parseFloat(eodSales.data.total_sales, 10) && (eodSales.data.eod > parseFloat(eodSales.data.total_sales) && 'Over +')} {(eodSales.data.eod < parseFloat(eodSales.data.total_sales) && 'Short -')}  ₱ {parseFloat(Math.abs(eodSales.data.eod - eodSales.data.total_sales)).toFixed(2)}</Box>
                            </Box>
                            <Box fontSize={14} fontWeight={400} color="red">Notes:</Box>
                            <CstmTextField fullWidth variant="outlined"
                                multiline
                                name="remarks"
                                value={form.remarks}
                                inputProps={{ maxLength: 2400, readOnly: true }} minRows={10} maxRows={10} 
                            />
                        </>
                    :
                        <>
                            <Box width="100%" display="flex" flexDirection="column" gap={1}>
                                <Box id="walkthrough-eod-sales-report-step-1">
                                    <Box fontSize={14} fontWeight={400}>Sales Entry:</Box>
                                    <CstmTextField fullWidth variant="outlined"
                                        onInput={(e)=>handleChange(e)}
                                        name="actual_sales"
                                        value={eodSales.data.display_actual_sales || ''}
                                        inputProps={{min: 0, style: { textAlign: 'right' }}} 
                                        error={eodSales.data.actual_sales === '.'}
                                    />
                                </Box>
                                <Box id="walkthrough-eod-sales-report-step-2">
                                    <Box fontSize={14} fontWeight={400} color="red">Notes:</Box>
                                    <CstmTextField fullWidth variant="outlined"
                                        
                                        onInput={(e)=>handleChange(e)}
                                        multiline
                                        name="remarks"
                                        value={form.remarks}
                                        inputProps={{ maxLength: 2400 }} minRows={10} maxRows={10} 
                                    />
                                </Box>
                            </Box>
                            <Box minHeight="80px" width="100%" py={2}>
                                <Box id="walkthrough-eod-sales-report-step-3" disabled={submitFormLoader.submit || isLoading} onClick={()=>submitHandler('submit')} component={Button} disableFocusRipple={true} height="100%" width="100%" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor={submitFormLoader.submit?"#fff":"primary.main"} color={submitFormLoader.submit?"#00000061":"#fff"} sx={{border:"1px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} px={3}>
                                    <Box fontSize={14} fontWeight={400} lineHeight="19px">Submit</Box>
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            }
            {!isLoading && <MessageModal open={navSession.data.isShow} close={()=>navSession.set({...navSession.data, isShow:false })} text={messageModal.data.text} subtext={messageModal.data.subText} trigger={false}/>}
            <ConfirmationWarning sm={sm} submitFormLoader={submitFormLoader} submitHandler={submitHandler} eodSales={eodSales.data}/>
        </Box>
    )
}